<template>
  <NuxtLink
    v-if="path && (!isTab ||isEnabled)"
    :to="path"
    class="py-2 px-3 rounded font-medium hover:bg-action hover:text-action transition-all flex items-center space-x-3"
    :class="classes"
  >
    <LayoutElementsIcon v-if="icon" :name="item.icon || icons[item.id]" />
    <div :class="icon ? 'text-left' : 'text-center'">
      <span class="block">{{ name }}</span>
      <span v-if="info && information" class="text-xs opacity-70">{{ information }}</span>
    </div>
  </NuxtLink>
</template>

<script setup lang="ts">
const { $site } = useNuxtApp()
const route = useRoute()

interface Props {
  item: {
    id: keyof typeof paths
    name: string
    type: string
    slug: string
    icon: string
    information: string
  }
  icon?: boolean
  info?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  icon: false,
  info: false
})

const paths = {
  book: "/book-now",
  timetable: "/timetable",
  lastMinute: "/last-minute",
  giftCard: "/gift",
  pass: "/pass",
  gallery: "/gallery",
  review: "/reviews",
  user: "/customer"
}

const icons = {
  book: "clock",
  timetable: "calendar-days",
  lastMinute: "bell-alert",
  giftCard: "gift",
  pass: "ticket",
  gallery: "photo",
  review: "star",
  user: "user"
}

const name = computed(() => {
  return props.item?.name || $site.tabs.getName(props.item?.id, props.item?.id)
})

const path = computed(() => {
  if (props.item?.type === 'custom') {
    return `/page/${props.item?.slug}`
  }

  return paths[props.item?.id]
})

const classes = computed(() => {
  const classes = []

    if (isActive.value) {
      classes.push('text-action bg-action')
    } else {
      classes.push('hover:text-action text-[var(--bookapp-hero-text-color)]')

      if (props.icon) {
        classes.push('text-secondary')
      } else {
        classes.push('text-[var(--bookapp-hero-text-color)]')
      }
    }

    return classes.join(' ')
})

const information = computed(() => {
  return props.item.information
})

const isActive = computed(() => {
  return route.path.startsWith(path.value)
})

const isEnabled = computed(() => {
  return !!$site.tabs[props.item?.id]
})

const isTab = computed(() => {
  return props.item?.type === 'tab'
})

const isHome = computed(() => {
  return route.path === '/'
})
</script>
